import { baseApi } from './baseApi';
import { normalizeKeys } from '../../utils/transform';

export interface AnalyticsSummary {
  totalExchanges: number;
  activeAgents: number;
  activeApplications: number;
  totalSpend: number;
}

export interface ConsumptionDataPoint {
  date: string;
  exchanges: number;
  spend: number;
}

export interface BudgetUtilization {
  appId: string;
  appName: string;
  used: number;
  cap: number;
}

export const analyticsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAnalyticsSummary: builder.query<AnalyticsSummary, { range?: string }>({
      query: ({ range = '30d' }) => `/portal/analytics/summary?range=${range}`,
      transformResponse: (response: unknown) => normalizeKeys<AnalyticsSummary>(response),
      providesTags: ['Analytics'],
    }),

    getConsumption: builder.query<ConsumptionDataPoint[], { range?: string; agentId?: string; appId?: string }>({
      query: ({ range = '30d', agentId, appId }) => {
        const params = new URLSearchParams({ range });
        if (agentId) params.set('agent_id', agentId);
        if (appId) params.set('app_id', appId);
        return `/portal/analytics/consumption?${params.toString()}`;
      },
      transformResponse: (response: unknown) => normalizeKeys<ConsumptionDataPoint[]>(response),
      providesTags: ['Analytics'],
    }),

    getBudgetUtilization: builder.query<BudgetUtilization[], void>({
      query: () => '/portal/analytics/budgets',
      transformResponse: (response: unknown) => normalizeKeys<BudgetUtilization[]>(response),
      providesTags: ['Analytics'],
    }),

    queryAnalytics: builder.mutation<{ answer: string; data?: unknown }, { query: string }>({
      query: (body) => ({
        url: '/portal/analytics/query',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useGetAnalyticsSummaryQuery,
  useGetConsumptionQuery,
  useGetBudgetUtilizationQuery,
  useQueryAnalyticsMutation,
} = analyticsApi;
